// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-6e16a274] .option-list {\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: visible;\n}\n[data-v-6e16a274] .option-list.tall-list {\n  max-height: 500px;\n  overflow-y: auto;\n  overflow-x: visible;\n}\n[data-v-6e16a274] .option-list .form-check {\n  padding-left: 1.75em;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
